import React from 'react';
import { BanknoteArrowUp, Database, ListFilter } from 'lucide-react';
import CustomButton from '../../../components/ui/buttons/CustomButton';
import CustomCheckbox from '../../../components/ui/checkboxes/CustomCheckbox';
import Select from '../../../components/ui/selects/Select';

const OffshoreSymbolsSidebar = ({
  bases = [],
  filterOptions = {},

  configFilters,
  setConfigFilters,
  handleChangeFilter,

  setShowManageBasesModal,
  setShowAddAssetModal,
}) => {
  return (
    <div className="bg-tealTransparent p-5 rounded-custom20 h-fit flex flex-col gap-5">
      <div className="bg-white p-5 rounded-custom20 gap-5 flex flex-col">
        <span className="flex items-center gap-2">
          <Database className="text-tealMedium" size={20} strokeWidth={1.5} />
          <h1 className="text-2xl font-semibold text-blueDarker">Bases</h1>
        </span>

        <div className="bg-blueLight px-6 py-1 overflow-y-auto" style={{ borderRadius: '10px', maxHeight: '200px' }}>
          {bases.map((base) => (
            <div key={base.id} className="flex items-center justify-between py-2">
              <div className="flex items-center gap-2 min-w-0">
                <span
                  className="inline-block flex-none"
                  style={{
                    backgroundColor: base.colorHex,
                    borderRadius: '4px',
                    width: '12px',
                    height: '12px',
                  }}
                />
                <span className="text-blueDarker truncate">{base.description}</span>
              </div>

              <span className="bg-blueLightest2 text-blueMedium inline-flex px-3 text-white py-1 rounded-full items-center justify-center text-xs uppercase font-semibold">
                {base.assetCount}
              </span>
            </div>
          ))}

          {bases.length === 0 ? <div className="py-3 text-blueDarker/70 text-sm">Nenhuma base cadastrada.</div> : null}
        </div>

        <span className="flex items-center gap-1 justify-between mb-2">
          <CustomButton onClick={() => setShowManageBasesModal(true)} fontSize="text-xs">
            GERENCIAR BASES
          </CustomButton>

          <CustomButton
            onClick={() => setShowAddAssetModal(true)}
            fontSize="text-xs"
            bgColor="bg-blueHighlight"
            borderColor="border-blueMediumDark2"
          >
            ADICIONAR ATIVO
          </CustomButton>
        </span>
      </div>

      <div className="bg-white p-5 rounded-custom20 gap-5 flex flex-col flex-1">
        <span className="flex items-center gap-2">
          <ListFilter className="text-tealMedium" size={20} strokeWidth={1.5} />
          <h1 className="text-2xl font-semibold text-blueDarker">Filtros</h1>
        </span>

        <div className="bg-blueLight p-4 flex flex-col gap-4" style={{ borderRadius: '10px' }}>
          <div className="flex items-center gap-2">
            <span className="text-tealMedium">
              <BanknoteArrowUp size={16} strokeWidth={1.5} />
            </span>
            <span className="text-blueDarker font-semibold text-lg">Classificação</span>
          </div>

          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-2 justify-between">
              <CustomCheckbox
                name="currencyEnabled"
                label="Moeda:"
                checked={configFilters.currencyEnabled}
                labelClassName="pl-2 text-base"
                onChange={() =>
                  setConfigFilters((prev) => ({
                    ...prev,
                    currencyEnabled: !prev.currencyEnabled,
                  }))
                }
              />

              <div className="w-40">
                <Select
                  name="currency"
                  options={[{ value: 'all', label: 'Todas' }, ...(filterOptions.currencies || [])]}
                  value={configFilters.currency}
                  onChange={handleChangeFilter}
                  className="w-40"
                  py={2}
                />
              </div>
            </div>

            <div className="flex items-center gap-2 justify-between">
              <CustomCheckbox
                name="exchangeEnabled"
                label="Exchange:"
                checked={configFilters.exchangeEnabled}
                labelClassName="pl-2 text-base"
                onChange={() =>
                  setConfigFilters((prev) => ({
                    ...prev,
                    exchangeEnabled: !prev.exchangeEnabled,
                  }))
                }
              />

              <div className="w-40">
                <Select
                  name="exchange"
                  options={[{ value: 'all', label: 'Todas' }, ...(filterOptions.exchanges || [])]}
                  value={configFilters.exchange}
                  onChange={handleChangeFilter}
                  className="w-40"
                  py={2}
                />
              </div>
            </div>

            <div className="flex items-center gap-2 justify-between">
              <CustomCheckbox
                name="countryEnabled"
                label="País:"
                checked={configFilters.countryEnabled}
                labelClassName="pl-2 text-base"
                onChange={() =>
                  setConfigFilters((prev) => ({
                    ...prev,
                    countryEnabled: !prev.countryEnabled,
                  }))
                }
              />

              <div className="w-40">
                <Select
                  name="country"
                  options={[{ value: 'all', label: 'Todos' }, ...(filterOptions.countries || [])]}
                  value={configFilters.country}
                  onChange={handleChangeFilter}
                  className="w-40"
                  py={2}
                />
              </div>
            </div>

            <div className="flex items-center gap-2 justify-between">
              <CustomCheckbox
                name="strategyEnabled"
                label="Estratégia:"
                checked={configFilters.strategyEnabled}
                onChange={() =>
                  setConfigFilters((prev) => ({
                    ...prev,
                    strategyEnabled: !prev.strategyEnabled,
                  }))
                }
                labelClassName="pl-2 text-base"
              />

              <div className="w-40">
                <Select
                  name="strategy"
                  options={[{ value: 'all', label: 'Todas' }, ...(filterOptions.strategies || [])]}
                  value={configFilters.strategy}
                  onChange={handleChangeFilter}
                  className="w-40"
                  py={2}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OffshoreSymbolsSidebar;
